import React from "react";

export default class NotFound extends React.Component {
    public render() {
        return <React.Fragment>
            <h1>Not Found</h1>
            <p>No page was found at this address.</p>
        </React.Fragment>;
    }
}